import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createEndorsementRejectedSlice = (set, get) => ({
    endorsementRejected: {
        loading: false,
        data: [],
        filtered: []
    },
    getEndorsementRejectedInfo: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ endorsementRejected: { ...state.endorsementRejected, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: "/v1/business/endorsement/rejected-report",
                headers: { token },
            });
            set(state => ({ endorsementRejected: { loading: false, data: resp.data, filtered: resp.data } }));
        } catch (error) {
            set(state => ({ endorsementRejected: { ...state.endorsementRejected, loading: false } }));
        }
    }
});
